export default {
  name: "Job Description",
  prefix: "E.a",
  sections: [
    {
      fields: [
        {
          code: "E.a.1",
          machine_name: "jobTitle",
          widget: "text",
          label: "Job Title",
          maxLength: 60,
          validate: ["required", "noNAs"],
          tooltip:
            "Enter the title of the job opportunity for which a prevailing wage determination is being sought by the employer.",
        },
        {
          code: "E.a.2",
          machine_name: "suggestedSocCode",
          widget: "soc",
          label: "Suggested SOC Occupational Code",
          field_to_modify: "suggestedSocTitle",
          validate: ["required", "noNAs"],
          tooltip:
            "Enter a suggested six or eight-digit Standard Occupational Classification (SOC)/ Occupational Information Network (O*NET) code for the occupation, which most clearly describes the work to be performed. For example, the eight or six-digit SOC code for a fruit or vegetable harvester or orchard worker is 39-9011.01 (Nannies).  The suggested SOC may be used as a tool in the wage determination process.  However, the SOC issued by the Department with the wage determination may differ.",
        },
        {
          code: "E.a.2a",
          machine_name: "suggestedSocTitle",
          widget: "text",
          label: "Suggested SOC Occupation Title",
          hidden: true,
          tooltip:
            "Enter a suggested occupational title associated with the SOC/O*NET (Occupational Employment Statistics) code.  For example, the occupational title associated with SOC/O*NET code 39.9011.01 is “Nannies.”  The suggested SOC may be used as a tool in the wage determination process.  However, the SOC issued by the Department with the wage determination may differ.",
        },
        {
          code: "E.a.3",
          machine_name: "supervisorJobTitle",
          widget: "text",
          label: "Job Title of Supervisor for this Position",
          maxLength: 60,
          tooltip:
            "Identify the title of the supervisor who will be supervising the work of the worker(s), if applicable.",
        },
        {
          isGroup: {
            code: "E.a.4",
            machine_name: "superviseOtherEmp",
            widget: "radio",
            label: "Does this position supervise the work of other employees?",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                clearSchema: [
                  "superviseHowMany",
                  "supervisionLevelSub",
                  "supervisionLevelPeer",
                ],
              },
            ],
            tooltip: `Mark “Yes” or “No” as to whether the job opportunity supervises the work of other employees.`,
          },
        },
        {
          code: "E.a.4a",
          machine_name: "superviseHowMany",
          widget: "text",
          label:
            "If 'Yes' to question E.a.4, enter the number of employees worker will supervise.",
          width: 2,
          maxLength: 4,
          validate: ["required", "number"],
          isVisible: {
            when: "superviseOtherEmp",
            is: "YES",
          },
          tooltip:
            "If “Yes” in question 4, enter the total number of employees the job opportunity will supervise.",
        },
        {
          isGroup: {
            code: "E.a.4b",
            label:
              "If 'Yes' to question E.a.4, indicate the level of the employees to be supervised.",
            width: 2,
            required: true,
            coloring: "grey",
            isVisible: {
              when: "superviseOtherEmp",
              is: "YES",
            },
            fields: [
              {
                machine_name: "supervisionLevelSub",
                widget: "checkbox_old",
                choice: "Subordinate",
                label: "Subordinate",
                value: "YES",
                hidden: true,
                validate: [
                  {
                    subsetOfSetRequired: "supervisionLevelSub",
                    message: "This field is required.",
                    needsFieldValues: true,
                    extraData: {
                      numRequired: 1,
                      fieldArray: [
                        "supervisionLevelSub",
                        "supervisionLevelPeer",
                      ],
                    },
                  },
                ],
              },
              {
                machine_name: "supervisionLevelPeer",
                widget: "checkbox_old",
                choice: "Peer",
                label: "Peer",
                value: "YES",
                hidden: true,
              },
            ],
            tooltip:
              "If “Yes” in question 4, indicate the level of the employee(s) to be supervised as either subordinate, and/or peer.  If the employee supervises other individuals in a lower level occupation (e.g., a Software Engineer supervising Programmers), those employees would be subordinates.  However, if any employee supervises other individuals in the same or equivalent occupation (e.g., a Software Engineer supervising other Software Engineers), those employees would be peers.",
          },
        },
        {
          code: "E.a.5",
          machine_name: "jobDuties",
          widget: "text_area",
          label:
            "Job duties - Please provide a description of the duties to be performed with as much specificity as possible, including details regarding the areas/fields and/or products/industries involved. A description of the job duties to be performed MUST begin in this space",
          rows: 8,
          inputLimit: 4000,
          validate: ["required", "noNAs"],
          tooltip:
            "Describe, the job duties in detail to be performed by any worker filling the job opportunity, including any equipment to be used, any supervisory responsibilities, and other pertinent work tasks.  The duties provided must be specific enough to be classified under a relevant SOC pursuant to the O*Net publication.  The entry in this field must be the same as the job duties disclosed on the Form ETA-9142C, <em>Application for Temporary Employment Certification</em>.<br /><br />All job duties must be disclosed in the space allotted on the form.  The employer may include one separate attachment where the space allotted is insufficient to fully respond to this collection item.  For employers filing electronically, the Department’s electronic filing system will automatically provide the employer with an addendum if the entry exceeds the allotted space on the form.  For employers filing applications by mail, the employer must begin its description of the job duties in the allotted space on the form and include one separate attachment, if necessary, to fully respond to this collection item.",
        },
        {
          isGroup: {
            code: "E.a.6",
            machine_name: "travelRequired",
            label:
              "Will travel be required in order to perform the job duties?",
            type: "radio",
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                clearSchema: ["travelDetails"],
              },
            ],
            tooltip:
              "Select “Yes” or “No” as to whether the job requires any travel.",
          },
        },
        {
          code: "E.a.6a",
          machine_name: "travelDetails",
          label: `If 'Yes' to question 6, please provide details of the travel required, such as area(s), frequency and nature of the travel. §`,
          widget: "text_area",
          rows: 4,
          inputLimit: 2000,
          validate: [
            {
              isRequired: "travelRequired",
              message:
                "Please enter the full description of the requirements: Area, frequency, nature",
              needsFieldValues: true,
              extraData: {
                valueOf: "YES",
              },
            },
            "noNAs",
          ],
          isVisible: {
            when: "travelRequired",
            is: "YES",
          },
          tooltip:
            "If “Yes” in question 6, provide details as to the area(s) of travel required, the frequency of the travel required, and the nature of the travel (e.g., whether relocation is/will be required).  Note that a prevailing wage cannot be provided for unanticipated worksites.  Please note that CW-1 workers may only travel within CNMI.",
        },
      ],
    },
  ],
};
